
import Vue, { PropType } from 'vue';
import ProductPreview from './components/ProductPreview.vue';
import ProductPreviewModal from './components/ProductPreviewModal.vue';
import { mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/v2/product';

export default Vue.extend({
  name: 'ProductManagement',

  components: {
    ProductPreview,
    ProductPreviewModal,
  },

  data() {
    return {
      isPreviewModalOpen: false,
    };
  },

  computed: {
    ...mapState(useProductStore, ['selectedPrintPosition']),
  },

  methods: {},
});
